import Swal, {SweetAlertIcon} from 'sweetalert2'

export const showSuccessMessage = (message: string, callback?: () => void) => {
  Swal.fire({
    title: message,
    icon: 'success',
    showConfirmButton: false,
    timer: 800,
    timerProgressBar: true,
  }).then(() => {
    callback?.()
  })
}

export const showErrorMessage = (message: string) => {
  Swal.fire({
    title: message,
    icon: 'error',
    showConfirmButton: false,
    timer: 900,
    timerProgressBar: true,
  })
}

export const showMessage = (
  title: string,
  icon: SweetAlertIcon | string,
  onConfirm?: () => void
) => {
  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm()
    }
  }

  Swal.fire({
    title: title,
    icon: icon as SweetAlertIcon,
  }).then((result) => {
    if (result.isConfirmed) {
      handleConfirm()
    }
  })
}

export const showConfirmation = (
  text: string,
  confirmText: string,
  cancelText: string,
  onConfirm: () => void,
  onCancel: () => void
) => {
  Swal.fire({
    text,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#0066B3',
    cancelButtonColor: '#F1416C',
    confirmButtonText: confirmText,
    cancelButtonText: cancelText,
    preConfirm: onConfirm, // Execute onConfirm directly
  })
}
